import { registerMsgHandler } from "userful-chronos-app-common-js/dist/message/messageRegistery";
import {
    RESPOND_DELETE_MODEL,
    RESPOND_ADD_MODEL,
    RESPOND_LIST_MODEL,
    RESPOND_LIST_MODEL_ALL,
} from "userful-chronos-app-common-js/dist/message/messageTypeDefinitions/eisenhower/eisenhowerMsgs";
import {
    OllamaModelWithId,
    OllamaModelEdge,
    CrudModel,
    OllamaDownloadProgress,
    OllamaModelListResponse,
} from "userful-chronos-app-common-js/dist/models/eisenhower/edgeSetup";
import eisenhowerStore from "../eisenhowerStore";
import { eisenhowerActions } from "../eisenhowerSlice";
import { GetModelNameFromID } from "userful-chronos-app-common-js/dist/models/eisenhower/model";

registerMsgHandler(RESPOND_ADD_MODEL, (payload) => {
    console.debug("receive RESPOND_ADD_MODEL");
    const data = JSON.parse(payload) as OllamaDownloadProgress;

    // if download succeeded → refresh list
    if (data.status === "success") {
        eisenhowerStore.dispatch(eisenhowerActions.requestListModelsToServer(data.edgeServerId));
        setTimeout(() => {
            const payload = `${data.edgeServerId.value}-${data.modelId}`;
            eisenhowerStore.dispatch(eisenhowerActions.removeToast(payload));
        }, 4000);
    } else {
        if (data.status.startsWith("pulling"))
            eisenhowerStore.dispatch(
                eisenhowerActions.addOrUpdateToast({
                    modelName: GetModelNameFromID(data.modelId),
                    total: Number(data.total),
                    completed: Number(data.completed),
                    id: `${data.edgeServerId.value}-${data.modelId}`,
                }),
            );
    }
});

registerMsgHandler(RESPOND_DELETE_MODEL, (payload) => {
    console.debug("receive RESPOND_DELETE_MODEL");
    const data = JSON.parse(payload) as CrudModel;
    eisenhowerStore.dispatch(eisenhowerActions.removeModel(data));
});

registerMsgHandler(RESPOND_LIST_MODEL, (payload) => {
    console.debug("receive RESPOND_LIST_MODEL");
    const models = JSON.parse(payload) as OllamaModelListResponse;
    const data = { id: models.edgeServerId, models: models.models } as OllamaModelEdge;
    eisenhowerStore.dispatch(eisenhowerActions.addOrUpdateOllamaModelEdge(data));
});

registerMsgHandler(RESPOND_LIST_MODEL_ALL, (payload) => {
    console.debug("receive RESPOND_LIST_MODEL_ALL");
    const data = JSON.parse(payload);
    const modelsData: OllamaModelEdge[] = data.map((d) => ({ id: d.edgeServerId, models: d.models }));
    eisenhowerStore.dispatch(eisenhowerActions.setEdgeModels(modelsData));
});
